import { FormikHelpers, Formik, Form } from "formik";
import { useSnackbar } from "notistack";
import * as yup from "yup";

import { Card, CardHeader, CardContent } from "@material-ui/core";

import { useTenant } from "src/components/LoggedInAdminProvider";
import FormikErrorBanner from "src/components/form/FormikErrorBanner";
import FormikTextField from "src/components/form/FormikTextField";
import SubmitButton from "src/components/form/SubmitButton";
import {
  tenantEditName,
  tenantEditNameVariables
} from "src/graphql/generated/tenantEditName";
import { EDIT_TENANT_NAME } from "src/graphql/tenant";
import useMutation from "src/util/useMutation";

type Values = { name: string };

export default function Basics(): JSX.Element {
  const tenant = useTenant()!;
  const snackbar = useSnackbar();

  const schema = yup.object().shape({
    name: yup.string().required("Required")
  });

  const [updateTenantName] = useMutation<
    tenantEditName,
    tenantEditNameVariables
  >(EDIT_TENANT_NAME, {
    onErrorSnackbarMessage: `Failed to update organization settings.`
  });

  async function handleSubmit(values: Values, helpers: FormikHelpers<Values>) {
    const { errors, data } = await updateTenantName({
      variables: {
        newName: values.name
      }
    });

    if (!errors) {
      snackbar.enqueueSnackbar("Organization updated.", { variant: "info" });
      helpers.resetForm({
        values: {
          name: data!.tenantEditName.name
        }
      });
    }
  }

  return (
    <>
      <Card>
        <CardHeader title="Name" />
        <CardContent>
          <Formik
            initialValues={{
              name: tenant.name
            }}
            onSubmit={handleSubmit}
            validationSchema={schema}
          >
            {({ isSubmitting, dirty }) => (
              <Form>
                <FormikErrorBanner />
                <FormikTextField
                  fullWidth
                  label="Organization Name"
                  name="name"
                  disabled={isSubmitting}
                />
                <SubmitButton
                  type="submit"
                  disabled={!dirty}
                  isSubmitting={isSubmitting}
                  submitText="Update"
                  loadingText="Updating..."
                />
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </>
  );
}
